import React, { useRef, useState, useEffect } from "react";
import "./Home.css";

export default function Home() {
    const targetRef = useRef();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (entry.isIntersecting && !isVisible) {
                setIsVisible(true);
            }
        });
        observer.observe(targetRef.current);
    }, [isVisible]);

    const className = "Home hidden " + (isVisible ? "show" : "");

    return (
        <section ref={targetRef} className={className} id="home">
            <div className="intro-content">
                <p className="eyebrow">
                    Serving Calgary and Alberta businesses
                </p>
                <h1 className="name">
                    Modernize your business operations with websites, automation, and AI.
                </h1>
                <h3 className="one-liner">
                    We help small businesses save time, improve systems, and look more professional online.
                </h3>
                <p className="description">
                    Stop wrestling with messy spreadsheets and manual processes. We provide practical IT consulting, custom software, and automation to streamline your day-to-day operations.
                </p>
                <div className="hero-cta-group">
                    <a className="hero-cta" href="https://calendar.app.google/YtNYViW1QVB9m5Xv6" target="_blank" rel="noreferrer">
                        Book a Consultation
                    </a>
                    <a className="hero-secondary-cta" href="mailto:gramlichsoftware@gmail.com">
                        Email Us
                    </a>
                </div>
            </div>
        </section>
    );
}
